import {DirectiveOptions} from 'vue'
import {isCoprolibNumber} from '@/helpers/validators'
import {convertAmount} from '@/helpers'

const convertAmountDirective: DirectiveOptions = {
  bind: function (el: any, binding, vNode) {
    el.val = binding.value
    el.handler = (e) => {
      const v = el.val
      if (v && v !== '' && isCoprolibNumber(v)) {
        e.target.value = convertAmount(v)
        vNode.elm.dispatchEvent(new CustomEvent('input'))
      }
    }
    el.addEventListener('change', el.handler)
  },
  update(el: any, binding, vNode) {
    el.val = binding.value
  },
  unbind: function (el: any) {
    el.removeEventListener('change', el.handler)
  }
}

export default convertAmountDirective
